import styled from "@emotion/styled";

const desktopWidths = [
  "0 0 32px",
  "1 0 25%",
  "1 0 15%",
  "1 0 15%",
  "1 0 calc(35% - 32px)",
];

const mobileWidths = [
  "0 0 32px",
  "1 0 36%",
  "0 0 calc(100% - 32px)",
  "0 0 calc(100% - 32px)",
  "1 0 calc(64% - 32px)",
];

const mobileOrders = [1, 2, 4, 5, 3];

export const ExpandLeftAndRight = styled.div`
  overflow-x: hidden;
  max-width: 100vw;
  ${({ theme }) => theme.breakpoints.xs.down} {
    margin-left: -15px;
    margin-right: -15px;
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  * {
    box-sizing: border-box;
  }
`;

export const TableHead = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: flex-end;
`;

export const Cell = styled.span`
  font-weight: 700;
  line-height: 1.2;
  ${desktopWidths.map(
    (widths, i) => `
      &:nth-of-type(${i + 1}) {
        flex: ${widths};
      }
    `
  )}
  ${({ theme }) => theme.breakpoints.sm.down} {
    ${mobileWidths.map(
      (widths, i) => `
      &:nth-of-type(${i + 1}) {
        flex: ${widths};
      }
    `
    )}
    ${({ hiddenMobile }) => hiddenMobile && `display: none;`}
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px 8px;
  align-items: center;
  justify-content: flex-end;

  &:nth-of-type(2n - 1) {
    background-color: ${({ theme }) => theme.colors.grey90};
  }
`;

export const Rank = styled.div`
  flex: ${desktopWidths[0]};
  line-height: 1;
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex: ${mobileWidths[0]};
    order: ${mobileOrders[0]};
  }
`;

export const StateName = styled.div`
  flex: ${desktopWidths[1]};
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex: ${mobileWidths[1]};
    order: ${mobileOrders[1]};
  }
`;

export const Population = styled.div`
  flex: ${desktopWidths[2]};
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex: ${mobileWidths[2]};
    order: ${mobileOrders[2]};
  }
`;

export const Votes = styled.div`
  flex: ${desktopWidths[3]};
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex: ${mobileWidths[3]};
    order: ${mobileOrders[3]};
  }
`;

export const Ratio = styled.div`
  flex: ${desktopWidths[4]};
  font-weight: 700;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  ${({ theme }) => theme.breakpoints.sm.down} {
    flex: ${mobileWidths[4]};
    order: ${mobileOrders[4]};
  }
`;

export const Value = styled.span`
  font-size: 12px;
  ${({ theme }) => theme.breakpoints.sm.down} {
    color: ${({ theme }) => theme.colors.grey40};
  }
`;

export const Unit = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey40};
  ${({ theme }) => theme.breakpoints.sm.up} {
    display: none;
  }
`;

export const Mask = styled.figure`
  display: inline-block;
  margin: 0 5px 0 0;
  width: ${({ cutOff }) => cutOff}px;
  overflow: hidden;

  &:first-of-type {
    margin-left: 12px;
  }

  svg {
    width: 18px;
    height: 21.73px;
  }
`;

export const ExpandButton = styled.button`
  ${({ theme }) => theme.snippets.resetButton};
  color: ${({ theme }) => theme.colors.links};
  padding: 16px 0;
  ${({ theme }) => theme.breakpoints.xs.down} {
    padding-left: 16px;
  }
  svg {
    overflow: visible !important;
  }
`;

export const Annotation = styled.div`
  margin-top: 12px;
  font-family: ${({ theme }) => theme.fonts.sans};
  color: ${({ theme }) => theme.colors.grey20};
  font-size: 12px;
  line-height: 1.2;
`;
